import { fork, takeEvery } from "redux-saga/effects";

import SettingConstant from "modules/setting/constants";
import SettingSagas from "modules/setting/sagas";

function* watchGetAllAdsList() {
  yield takeEvery(SettingConstant.GET_ALL_ADS_LIST, SettingSagas.GetAllAdsList);
}

function* watchChangeConnectedAds() {
  yield takeEvery(SettingConstant.CHANGE_CONNECTED_ADS, SettingSagas.ChangeConnectedAds);
}

function* watchClearChangeConnectedAds() {
  yield takeEvery(SettingConstant.CLEAR_CHANGE_CONNECTED_ADS_RESULT, SettingSagas.ClearChangeConnectedAdsResult);
}

export default [fork(watchGetAllAdsList), fork(watchChangeConnectedAds), fork(watchClearChangeConnectedAds)];
